/**
 * Header component for the interview booking application
 * Displays Juniva logo and tagline
 */
export function Header() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <a
          href="https://juniva.de"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        >
          {/* Juniva Logo - Text-based for simplicity, can be replaced with image */}
          <div className="flex items-center">
            <span className="text-2xl font-bold text-primary-600">Juniva</span>
          </div>
          {/* Tagline */}
          <span className="hidden sm:inline-block text-sm text-gray-500 border-l border-gray-300 pl-3">
            MUT. CHANCEN. ZUKUNFT.
          </span>
        </a>
      </div>
    </header>
  );
}
